// @flow
import * as React from 'react';
import {
  Checkbox, RadioGroup, Radio, TextArea, Text,
} from 'informed';

import { PrimaryText, Label } from '../../../Typography.jsx';
import developmentItems from '../developmentItems';

import styles from '../../../../styles/patientPages/wellChildCheck/Development.scss';

type Props = {
  developmentMilestones: boolean[],
  developmentNormal: boolean,
  developmentNotes: string,
  developmentGrade: string,
  type: number,
}

class EditDevelopment extends React.Component<Props> {
  render() {
    const developmentContent = developmentItems[this.props.type].map(
      (item, index) => (
        <tr key={item}>
          <td>
            <Checkbox
              field={`developmentMilestones[${index}]`}
              initialValue={this.props.developmentMilestones[index] || false}
            />
          </td>
          <td>
            {item}
            {(item === 'Grade')
              && <Text
                className={styles.gradeInput}
                field='developmentGrade'
                initialValue={this.props.developmentGrade} size={2}
              />}
          </td>
        </tr>
      ),
    );

    return (
      <div>
        <PrimaryText>Development Milestones</PrimaryText>
        <table>
          <tbody>
            {developmentContent}
          </tbody>
        </table>
        <br />
        <div>
          <PrimaryText>Development Result</PrimaryText>
          <RadioGroup field='developmentNormal' initialValue={this.props.developmentNormal}>
            <div><Radio value={true} />Normal</div>
            <div><Radio value={false} />Delayed</div>
          </RadioGroup>
        </div>
        <div>
          <Label>Development Notes</Label>
          <TextArea field='developmentNotes' initialValue={this.props.developmentNotes} />
        </div>
      </div>
    );
  }
}

export default EditDevelopment;



// WEBPACK FOOTER //
// ./client/src/components/patientPages/wellChildCheck/edit/EditDevelopment.jsx